import Vue from 'vue'
import App from '@/layout/app'
import router from './router'
import store from './store'
import Plugins from './plugins'
import GlobalComponents from './components'
import Bootstrap from './bootstrap'
import VModal from 'vue-js-modal'
import Filters from './filters'
import VueCarousel from 'vue-carousel'
import Vodal from 'vodal'
import VueSilentbox from 'vue-silentbox'
import VTooltip from 'v-tooltip'

Vue.use(VueSilentbox)

Vue.use(VTooltip)

Vue.component(Vodal.name, Vodal)

const VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo)

Vue.use(VueCarousel)
require('vodal/common.css')
require('vodal/zoom.css')

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VModal)

Vue.config.productionTip = false

Plugins(Vue, store, router)
Filters(Vue)
GlobalComponents(Vue)
Bootstrap(Vue, store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js